import getQuery from '../query';
import { user } from '../../api';
import { handleError } from '../errorHandling';

const queryClient = getQuery();

export const PHONE_VERIFICATION_START = 'phone_verification.start';
export const PHONE_VERIFICATION_VERIFY = 'phone_verification.verify';
export const PHONE_VERIFICATION_SEND_AUTHY = 'phone.phoneVerifyAuthyId';
export const PHONE_TRANSACTION_VERIFICATION_SEND_AUTHY = 'phone.phoneVerifyTransaction';
export const RESET_OTP = 'user.resetOTP';
export const VERIFY_RESET_OTP = 'user.verifyResetOTP';
export const USER_DETAILS_UPDATE_KEY = 'user.details';
export const ADD_HARD_WALLET_ID_TO_WALLET = 'user.addHardWalletIdToWallet';
export const USER_LIFETIME_TRANSACTIONS = 'user.lifetimeTransactions';

queryClient.setMutationDefaults(PHONE_VERIFICATION_START, {
  mutationFn: user.phoneVerify,
  onError: (error) => {
    handleError(error);
  },
});

queryClient.setMutationDefaults(PHONE_VERIFICATION_VERIFY, {
  mutationFn: user.phoneCheck,
  onError: (error) => {
    handleError(error);
  },
});

queryClient.setMutationDefaults(PHONE_VERIFICATION_SEND_AUTHY, {
  mutationFn: user.phoneVerifyAuthyId,
  onError: (error) => {
    handleError(error);
  },
});

queryClient.setMutationDefaults(PHONE_TRANSACTION_VERIFICATION_SEND_AUTHY, {
  mutationFn: user.phoneVerifyTransaction,
  onError: (error) => {
    handleError(error);
  },
});

queryClient.setMutationDefaults(RESET_OTP, {
  mutationFn: user.resetOTP,
  onError: (error) => {
    handleError(error);
  },
});

queryClient.setMutationDefaults(VERIFY_RESET_OTP, {
  mutationFn: user.verifyResetOtp,
  onError: (error) => {
    handleError(error);
  },
});

queryClient.setMutationDefaults(USER_DETAILS_UPDATE_KEY, {
  mutationFn: () => user.details(),
  onSuccess: (result) => {
    queryClient.setQueryData(USER_DETAILS_UPDATE_KEY, () => result);
  },
});
queryClient.setMutationDefaults(ADD_HARD_WALLET_ID_TO_WALLET, {
  mutationFn: user.addHardWalletIdToWallet,
});

queryClient.setQueryDefaults(USER_LIFETIME_TRANSACTIONS, {
  queryFn: ({ queryKey }) => user.lifetimeTransaction(queryKey[1]),
  onError: (error) => {
    handleError(error);
  },
});
